import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import {
  GenericLinkModule,
  IconModule,
  KeyboardFocusModule,
  MediaModule,
  OutletModule,
  PageComponentModule,
} from '@spartacus/storefront';
import { NavigationComponent } from './navigation.component';
import { GgBreadcrumbComponent } from './gg-breadcrumb/gg-breadcrumb.component';
import { RouterModule } from '@angular/router';
import { GgGridItemComponent } from './gg-grid-item/gg-grid-item.component';
import { TestIdDirective } from '../../../directives/TestIdDirective';
import { GgNavigationDropdownComponent } from './gg-navigation-dropdown/navigation-dropdown.component';

@NgModule({
  declarations: [NavigationComponent, GgBreadcrumbComponent, GgNavigationDropdownComponent],
  imports: [
    GenericLinkModule,
    IconModule,
    CommonModule,
    KeyboardFocusModule,
    MediaModule,
    TestIdDirective,
    PageComponentModule,
    OutletModule,
    GenericLinkModule,
    I18nModule,
    RouterModule,
    ConfigModule.withConfig({
      cmsComponents: {
        NavigationComponent: {
          component: NavigationComponent,
        },
        BreadcrumbComponent: {
          component: GgBreadcrumbComponent,
        },
        CategoryNavigationComponent: {
          component: NavigationComponent,
        },
        GGGridItemComponent: {
          component: GgGridItemComponent,
        },
      },
    } as CmsConfig),
  ],
})
export class NavigationModule {}
